import React from "react";
import { Typography } from "@mui/material";
import { sectionTitleStyle } from "./SectionTitle";

export default function ColorizedText({
  text = "",
  sx = {},
  variant = "h4",    // default title style
  weight = 700,
  ...props
}) {
  if (!text) return null;

  const parts = [];
  const regex = /\[(\w+)\](.*?)\[\/\1\]/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const colorName = match[1].toLowerCase();
    const innerText = match[2];

    const colorMap = {
      blue: "#0b69b2",
      red: "#c62828",
      green: "#2e7d32",
      tgns: "#b6a810",
      purple: "#5400ce"
    };

    const color = colorMap[colorName] || "inherit";

    parts.push(
      <span key={match.index} style={{ color, fontWeight: weight }}>
        {innerText}
      </span>
    );

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return (
    <Typography
      variant={variant}
      sx={{ ...sectionTitleStyle, ...sx }}
      {...props}
    >
      {parts.map((part, i) =>
        typeof part === "string" ? <React.Fragment key={i}>{part}</React.Fragment> : part
      )}
    </Typography>
  );
}
